import { MessageHandler } from '@bigcommerce/page-builder-sdk';

import CarouselWidget from '../lib/carouselProps';

import { HighlightChildElementPayload, PageBuilderApiActionType } from './constants';

interface HighlightSpecificSlideMessage {
    event: MessageEvent;
    widgetUuid: string;
    carouselInstance: CarouselWidget;
    data: HighlightChildElementPayload;
}

const highlightSpecificSlide: MessageHandler = ({
    carouselInstance,
    data,
    widgetUuid,
}: HighlightSpecificSlideMessage): void => {
    // We dont care about events for other widgets
    if (widgetUuid !== data.widgetUuid) {
        return;
    }

    // We can skip this event if the carousel isn't in the dom
    if (!carouselInstance.getContainer()) {
        return;
    }

    // We dont care about non "highlight child element" events
    if (data.action !== PageBuilderApiActionType.HIGHLIGHT_CHILD_ELEMENT) {
        return;
    }

    const { attribute, index } = data.payload;
    if (attribute !== 'slides') {
        return;
    }

    // Go to the specified index
    carouselInstance.goTo(index);
};

export default highlightSpecificSlide;
